import type { JSX } from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import type { RefereeQuestionForReferee } from '../types/referee-app.types';

interface RefereeSectionProps {
  questions: RefereeQuestionForReferee[];
  answers: Record<string, string>;
  onAnswerChange: (questionId: string, value: string) => void;
  errors: Record<string, string | undefined>;
}

export function RefereeQuestionsSection({
  questions,
  answers,
  onAnswerChange,
  errors,
}: RefereeSectionProps): JSX.Element {
  return (
    <div className="space-y-4">
      {questions.map((question) => (
        <div key={question.id} className="space-y-2" data-question-id={question.id}>
          <Label htmlFor={`answer-${question.id}`}>
            {question.text}
            {question.isRequired && <span className="ml-1 text-destructive">*</span>}
          </Label>
          <Textarea
            id={`answer-${question.id}`}
            value={answers[question.id] ?? ''}
            onChange={(e) => onAnswerChange(question.id, e.target.value)}
            rows={3}
            aria-required={question.isRequired}
          />
          {errors[question.id] && <p className="text-sm text-destructive">{errors[question.id]}</p>}
        </div>
      ))}
    </div>
  );
}
